import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      redirect: "/index"
    },
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/admin/login/login"], resolve),
      meta: { title: "登錄" }
    },
    {
      path: "/registered",
      name: "registered",
      component: resolve => require(["@/admin/registered/registered"], resolve),
      meta: { title: "註冊" }
    },
    {
      path: "/",
      component: resolve => require(["@/admin/center/center"], resolve),
      meta: { title: "主頁" },
      children: [
        {
          path: "/index", //首頁
          component: resolve => require(["@/admin/index/index"], resolve),
          meta: { title: "首頁", permission: true }
        },
        {
          path: "/institutionInfo", //商户管理
          name: "institutionInfo",
          component: resolve => require(["@/admin/institution/info"], resolve),
          meta: { title: "商戶信息", permission: true }
        },
        {
          path: "/institutionEdit", //商户管理--商户編輯
          name: "institutionEdit",
          component: resolve => require(["@/admin/institution/edit"], resolve),
          meta: { title: "商户編輯" }
        },
        {
          path: "/transactionIncome", //退款查询
          name: "transactionIncome",
          component: resolve =>
            require(["@/admin/transaction/income"], resolve),
          meta: { title: "退款查詢", permission: true }
        },
        {
          path: "/transactionDivided", //商戶日結
          name: "transactionDivided",
          component: resolve =>
            require(["@/admin/transaction/divided"], resolve),
          meta: { title: "商戶日結", permission: true }
        },
        {
          path: "/merchantInfo", //賬戶管理--账户管理
          name: "merchantInfo",
          component: resolve =>
            require(["@/admin/account/accountinfo"], resolve),
          meta: { title: "账户管理", permission: true }
        },
        {
          path: "/accountlook", //賬戶管理--查看賬戶信息
          name: "accountlook",
          component: resolve => require(["@/admin/account/look"], resolve),
          meta: { title: "查看賬戶信息" }
        },
        {
          path: "/accountinfo", //訂單流水
          name: "accountinfo",
          component: resolve => require(["@/admin/order/orderinfo"], resolve),
          meta: { title: "訂單流水" }
        },
        {
          path: "/orderlook", //訂單詳情
          name: "orderlook",
          component: resolve => require(["@/admin/order/look"], resolve),
          meta: { title: "訂單詳情" }
        },
        {
          path : '/ewmConfig',//收款二維碼
          name : 'ewmConfig',
          component: resolve => require(['@/admin/account/ewmConfig'], resolve),
          meta: { title: '收款二維碼' }
        },
        /*        {
          path : '/InviteMerchants',//邀请商户赚赏金
          name : 'InviteMerchants',
          component: resolve => require(['@/admin/InviteMerchants/InviteMerchants'], resolve),
          meta: { title: '邀请商户赚赏金' }
        },*/
        {
          path: "/storeManagement",
          name: "storeManagement",
          component: resolve =>
            require(["@/admin/storeManagement/list"], resolve),
          meta: { title: "门店管理", permission: true }
        },
        {
          path: "/storeManagementAdd",
          name: "storeManagementAdd",
          component: resolve =>
            require(["@/admin/storeManagement/add"], resolve),
          meta: { title: "门店編輯" }
        },
        {
          path: "/clerkList",
          name: "clerkList",
          component: resolve => require(["@/admin/clerkList/list"], resolve),
          meta: { title: "店員管理", permission: true }
        },
        {
          path: "/clerkAdd",
          name: "clerkAdd",
          component: resolve => require(["@/admin/clerkList/add"], resolve),
          meta: { title: "新增店員" }
        },
        {
          path: "*", //404
          name: "notFind",
          component: resolve => require(["@/admin/notFind/notFind"], resolve),
          meta: { title: "404找不到頁面" }
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.path === '/ewmConfig' || to.name === 'ewmConfig') {
    const partnerConfig = store.state.partnerConfig;
    if (partnerConfig && partnerConfig.hideReceiptModule) {
      next({ path: '/index', replace: true });
      return;
    }
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js